var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconArchive = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 26,
  height: 27,
  viewBox: "0 0 26 27",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "columns",
  clipPath: "url(#clip0_3207_14573)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Vector",
  d: "M19.1111 3.99994H5.88889C4.84568 3.99994 4 4.89537 4 5.99994V19.9999C4 21.1045 4.84568 21.9999 5.88889 21.9999H19.1111C20.1543 21.9999 21 21.1045 21 19.9999V5.99994C21 4.89537 20.1543 3.99994 19.1111 3.99994Z",
  stroke: "white",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_2",
  d: "M3.5 1.99994V6.00015",
  stroke: "white",
  strokeWidth: 2.00005,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_3",
  d: "M1.5 3.99994H5.5",
  stroke: "white",
  strokeWidth: 2.00005,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("line", {
  id: "Line 94",
  x1: 7.5,
  y1: 7.99994,
  x2: 17.5,
  y2: 7.99994,
  stroke: "white",
  strokeWidth: 2,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("line", {
  id: "Line 95",
  x1: 7.5,
  y1: 11.9999,
  x2: 17.5,
  y2: 11.9999,
  stroke: "white",
  strokeWidth: 2,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("line", {
  id: "Line 96",
  x1: 7.5,
  y1: 15.9999,
  x2: 12.5,
  y2: 15.9999,
  stroke: "white",
  strokeWidth: 2,
  strokeLinecap: "round"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_3207_14573"
}, /*#__PURE__*/React.createElement("rect", {
  width: 25,
  height: 26,
  fill: "white",
  transform: "translate(0.5 0.566833)"
})))));
export default SvgIconArchive;